import {useContext} from 'react';
import AppContext from '../../../contexts/app-context';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PatientCardStyle from './PatientCard.module';
import { motion } from 'framer-motion';

const PatientCard = ({ patient }) => {
  const classes = PatientCardStyle();
  const navigate = useNavigate();
  const appCtx = useContext(AppContext);
  // Extract patient information
  const patientName = patient.user?.name || patient.name || 'Unknown Patient';
  const patientGender = patient.user?.gender || patient.gender || 'N/A';
  const patientId = patient.id || '';

  // Get age from user object
  const age = patient.user?.age || 'N/A';

  // Get insurance information from backend fields
  const primaryInsurance = patient.primary_insurance_name || null;
  const secondaryInsurance = patient.secondary_insurance_name || null;

  // Get initials for avatar
  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name[0].toUpperCase();
  };

  const handleCardClick = () => {
    appCtx.addSelectedUser(patient);
    navigate(`/patient/${patientId}`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Box sx={classes.card} onClick={handleCardClick}>
        <Box sx={classes.cardContent}>
          {/* Avatar */}
          <Box sx={classes.avatar}>
            {getInitials(patientName)}
          </Box>

          {/* Patient Information */}
          <Box sx={classes.infoSection}>
            <Typography sx={classes.patientName}>
              {patientName}
            </Typography>

            <Box sx={classes.infoRow}>

              <Box sx={classes.infoItem}>
                <Typography sx={classes.label}>Gender</Typography>
                <Typography sx={classes.value}>
                  {patientGender === 'F' ? 'Female' : patientGender === 'M' ? 'Male' : patientGender}
                </Typography>
              </Box>

              <Box sx={classes.infoItem}>
                <Typography sx={classes.label}>Age</Typography>
                <Typography sx={classes.value}>
                  {age !== 'N/A' ? `${age} years` : 'N/A'}
                </Typography>
              </Box>

              <Box sx={classes.infoItem}>
                <Typography sx={classes.label}>Primary Insurance</Typography>
                <Typography sx={classes.value}>
                  {primaryInsurance || 'None'}
                </Typography>
              </Box>

              <Box sx={classes.infoItem}>
                <Typography sx={classes.label}>Secondary Insurance</Typography>
                <Typography sx={classes.value}>
                  {secondaryInsurance || 'None'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </motion.div>
  );
};

export default PatientCard;
